import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  focusAfterTimeout,
  getIcon,
} from './../../util';

import {
  updatePublicProfile,
  getCurrentTimestamp,
} from './../../actions';

import {
  Localize,
  CountrySelect,
} from '../shared';

class ManageProfile extends Component {

  state = {
    formError: null,
    firstName: '',
    lastName: '',
    syncingWithServer: false,
  }

  formIsValid(){
    const {
      firstName,
      lastName,
      country,
      dataPreference,
    } = this.state;

    return firstName !== '' && lastName !== '';
  }

  initializeProfileData(){

    if(!this.formIsValid()){

      this.setState({
        formError: 'Make sure all fields are filled out'
      });

      return;
    }

    const {
      firstName,
      lastName,
      syncingWithServer,
    } = this.state;

    this.props.updatePublicProfile({
      firstName,
      lastName,
    });
  }

  handleSubmit(event){
    event.preventDefault();

    if(this.formIsValid()){
      this.initializeProfileData();
    }
  }

  updateField(fieldName, fieldValue){
    this.setState({
      [fieldName]: fieldValue,
      formError: false,
    });
  }

  formIsDirty(){

    const {
      firstName,
      lastName,
      country,
      dataPreference,
    } = this.props.user;

    return  this.state.firstName !== firstName ||
            this.state.lastName !== lastName ||
            this.state.country !== country ||
            this.state.dataPreference !== dataPreference;
  }

  componentDidMount(){
    focusAfterTimeout(this, 'firstNameInput');

    const {
      firstName,
      lastName,
      country,
      dataPreference,
    } = this.props.user;

    this.setState({
      firstName,
      lastName,
      country,
      dataPreference,
    })
  }

  render(){

    const {
      firstName,
      lastName,
      country,
      dataPreference,
      formError,
      syncingWithServer,
    } = this.state;

    const orgDisplayName = this.props.orgConfig ? this.props.orgConfig.displayName : '';

    return (
      <div className="page initialize-profile">
        <form className="velocity-form page-form" onSubmit={this.handleSubmit.bind(this)}>
          <h2>Manage Profile</h2>

          {formError &&
            <div className="form-message error">{formError}</div>
          }

          <div className="form-group">
            <label htmlFor="velocity-first-name">First Name</label>
            <input ref={input => { this.firstNameInput = input; }} id="velocity-first-name" disabled={syncingWithServer} type="text" placeholder="First Name" value={firstName} onChange={(e) => { this.updateField('firstName', e.target.value); } } />
          </div>

          <div className="form-group">
            <label htmlFor="velocity-last-name">Last Name</label>
            <input id="velocity-last-name" disabled={syncingWithServer} type="text" placeholder="Last Name" value={lastName} onChange={(e) => { this.updateField('lastName', e.target.value); } } />
          </div>

          <div className="form-group">
            <label>Country</label>
            <CountrySelect
              className="hello"
              currentCountry={country}
              changeCountry={newCountry => { this.updateField('country', newCountry); }}
              />
          </div>

          <div className="form-group">
            <label>Account Privacy</label>
            <div className="profile-privacy-preference">
              <div
                onClick={() => { this.updateField('dataPreference', 'secured'); }}
                className={`option ${dataPreference === 'secured' ? 'selected' : ''}`}
              >
                {getIcon('hidden-folder')}
                <h6>KEEP MY DATA</h6>
                <p>Keep my assessment data linked to my account so I can access my results later.</p>
              </div>
              <div
                onClick={() => { this.updateField('dataPreference', 'anonomous'); }}
                className={`option ${dataPreference === 'anonomous' ? 'selected' : ''}`}
              >
                {getIcon('anonomyze')}
                <h6>PURGE MY DATA</h6>
                <p>Permanently delete my account and anonomyze my assessment results after reviewed or 60 days after assessment completion, whichever comes first.</p>
              </div>
            </div>
          </div>

          <button disabled={!this.formIsDirty()} onClick={this.initializeProfileData.bind(this)} className="button primary full-width">Save Changes</button>
        </form>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    orgConfig: state.orgConfig.data,
  }
}

export default connect(mapStateToProps, {updatePublicProfile})(ManageProfile);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/manageProfile.js